export var partnerAccountCodesMapper = function (response) {
    var _a;
    var partnerAccounts = [];
    if (response === null || response === void 0 ? void 0 : response.success) {
        partnerAccounts = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.map(function (partnerAccount) { return ({
            partnerId: partnerAccount === null || partnerAccount === void 0 ? void 0 : partnerAccount.partner_id,
            partnerCode: partnerAccount === null || partnerAccount === void 0 ? void 0 : partnerAccount.partner_code,
            partnerName: partnerAccount === null || partnerAccount === void 0 ? void 0 : partnerAccount.partner_name,
            partnerType: partnerAccount === null || partnerAccount === void 0 ? void 0 : partnerAccount.partner_type,
            upcId: partnerAccount === null || partnerAccount === void 0 ? void 0 : partnerAccount.upcid,
            upcCode: partnerAccount === null || partnerAccount === void 0 ? void 0 : partnerAccount.upccode,
            flag: partnerAccount === null || partnerAccount === void 0 ? void 0 : partnerAccount.flg,
        }); });
    }
    return { partnerAccounts: partnerAccounts };
};
